export default __webpack_public_path__ + "static/media/tokenomicMb3.73dc5867.png";